import React, { PropTypes } from 'react'
import ShareThis from './share-this'

class ResourceListItem extends React.Component{
	render(){
		let className = ['grid-item', 'post'];

		let featuredImage = '';
		if(this.props.featuredImage){
			featuredImage = <a href={ this.props.permalink } className="featured-image" style={{ backgroundImage: `url('${this.props.featuredImage}')` }} />
		}
		let tags = this.props.terms.map((tag, i) => {
			return <a href={tag.link} key={`tag_${i}`} className="category" dangerouslySetInnerHTML={{__html: tag.name}} />
		});
		let tagList = null;
		if(tags.length > 0){
			tagList = <span className="categories">{ tags }</span>
		}

		return (
			<div className={ className.join(' ') }>
				{ featuredImage }
				<div className="post-information">
					<a href={ this.props.permalink } className="post-title" dangerouslySetInnerHTML={{__html: this.props.title}} />
					{ tagList }
					<div className="excerpt core" dangerouslySetInnerHTML={{__html: this.props.excerpt}} />
					<div className="post-links">
						<a href={ this.props.permalink } className="button button-slide button-slide-small"><span>Read More</span></a>
						<ShareThis text={ this.props.title } url={this.props.permalink} />
					</div>
				</div>
			</div>
		);
	}

	componentDidMount(){
		if(window.grunticon){
			window.grunticon.embedSVG()
		}
	}

	componentDidUpdate() {
		if(window.grunticon){
			window.grunticon.embedSVG()
		}
	}
}

ResourceListItem.propTypes = {
	permalink: PropTypes.string.isRequired,
	featuredImage: PropTypes.string,
	title: PropTypes.string.isRequired,
	terms: PropTypes.array,
	excerpt: PropTypes.string.isRequired
};

export default ResourceListItem;



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/components/resource-list-item.js